import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { OccupationMicroService } from '@cpd-app/core-module/services';
import { OccupationQuickMatchModel } from '@cpd-app/core-module/models';

import * as MajorActions from './major.actions';
import { ErrorReceived } from '../error/error.actions';

@Injectable()
export class MajorEffects {
  constructor(
    private actions$: Actions,
    private occupationMicroService: OccupationMicroService
  ) {}

  setMajor$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MajorActions.setMajor),
      switchMap((action) => {
        return this.occupationMicroService
          .getOccupationListByMajor(action.majorModel)
          .pipe(
            map((occupationList: OccupationQuickMatchModel[]) =>
              MajorActions.receivedOccupationList({ entities: occupationList })
            ),
            catchError((error) => of(ErrorReceived({ error })))
          );
      })
    );
  });
}
